import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=7e067fb8&scoped=true"
import script from "./StartButton.vue?vue&type=script&lang=ts"
export * from "./StartButton.vue?vue&type=script&lang=ts"
import style0 from "./StartButton.vue?vue&type=style&index=0&id=7e067fb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e067fb8",
  null
  
)

export default component.exports